<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2020-03-24',
        items: [

          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-479',
            rare        : 'RR',
            name        : 'レインボーアイランジュワンピ',
            imgUrl      : '/images/items/AM-479.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-480',
            rare        : 'RR',
            name        : 'レインボーアイランジュシューズ',
            imgUrl      : '/images/bg/rainbow_01.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'RM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-481',
            rare        : 'RR',
            name        : 'レインボーアイランジュヘアアクセ',
            imgUrl      : '/images/bg/rainbow_01.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'RM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'RR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-430',
            rare        : 'PR',
            name        : 'ファンタジースノーホワイトトップス',
            imgUrl      : '/images/items/AM-430.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-431',
            rare        : 'PR',
            name        : 'ファンタジースノーホワイトスカート',
            imgUrl      : '/images/items/AM-431.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-432',
            rare        : 'PR',
            name        : 'ファンタジースノーホワイトシューズ',
            imgUrl      : '/images/items/AM-432.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-433',
            rare        : 'PR',
            name        : 'ファンタジースノーホワイトヘアアクセ',
            imgUrl      : '/images/items/AM-433.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-434',
            rare        : 'PR',
            name        : 'ひるのアナザーワンピ',
            imgUrl      : '/images/items/AM-434.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'PP_CG',
            type        : 'PR',
            point       : 1610,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-435',
            rare        : 'PR',
            name        : 'ひるのアナザーシューズ',
            imgUrl      : '/images/items/AM-435.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'PP_CG',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-436',
            rare        : 'PR',
            name        : 'ひるのアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-436.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PP_CG',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'PR',
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-437',
            rare        : 'PR',
            name        : 'スーパーサイリウムファルルアナザーワンピ',
            imgUrl      : '/images/items/AM-437.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'PP_MM',
            type        : 'LO',
            point       : 1610,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-438',
            rare        : 'PR',
            name        : 'スーパーサイリウムファルルアナザーシューズ',
            imgUrl      : '/images/items/AM-438.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PP_MM',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-439',
            rare        : 'PR',
            name        : 'スーパーサイリウムファルルアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-439.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'PP_MM',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-440',
            rare        : 'SR',
            name        : 'ミス・ドラマティックピンクトップス',
            imgUrl      : '/images/items/AM-440.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-441',
            rare        : 'SR',
            name        : 'ミス・ドラマティックピンクスカート',
            imgUrl      : '/images/items/AM-441.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-442',
            rare        : 'SR',
            name        : 'ミス・ドラマティックピンクシューズ',
            imgUrl      : '/images/items/AM-442.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-443',
            rare        : 'SR',
            name        : 'ミス・ドラマティックピンクヘアアクセ',
            imgUrl      : '/images/items/AM-443.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-444',
            rare        : 'SR',
            name        : 'メルティリリィホワイトサイリウムワンピ',
            imgUrl      : '/images/items/AM-444.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PP_ML',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-445',
            rare        : 'SR',
            name        : 'メルティリリィホワイトサイリウムシューズ',
            imgUrl      : '/images/items/AM-445.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PP_ML',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-446',
            rare        : 'SR',
            name        : 'メルティリリィホワイトサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-446.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PP_ML',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'SR',
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-447',
            rare        : 'SR',
            name        : 'ゆめみるおとめブラックワンピ',
            imgUrl      : '/images/items/AM-447.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-448',
            rare        : 'SR',
            name        : 'ゆめみるおとめブラックシューズ',
            imgUrl      : '/images/items/AM-448.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-449',
            rare        : 'SR',
            name        : 'ゆめみるおとめブラックヘアアクセ',
            imgUrl      : '/images/items/AM-449.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-450',
            rare        : 'R',
            name        : 'ヒップホップダンススカイトップス',
            imgUrl      : '/images/items/AM-450.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-451',
            rare        : 'R',
            name        : 'ヒップホップダンススカイパンツ',
            imgUrl      : '/images/items/AM-451.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-452',
            rare        : 'R',
            name        : 'ヒップホップダンススカイシューズ',
            imgUrl      : '/images/items/AM-452.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-453',
            rare        : 'R',
            name        : 'ヒップホップダンススカイヘアアクセ',
            imgUrl      : '/images/items/AM-453.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            id          : 'AM-454',
            rare        : 'R',
            name        : 'エンジェルナースダークトップス',
            imgUrl      : '/images/items/AM-454.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            id          : 'AM-455',
            rare        : 'R',
            name        : 'エンジェルナースダークスカート',
            imgUrl      : '/images/items/AM-455.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            id          : 'AM-456',
            rare        : 'R',
            name        : 'エンジェルナースダークシューズ',
            imgUrl      : '/images/items/AM-456.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            id          : 'AM-457',
            rare        : 'R',
            name        : 'エンジェルナースダークヘアアクセ',
            imgUrl      : '/images/items/AM-457.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            id          : 'AM-458',
            rare        : 'R',
            name        : 'スクール☆ガールゆめかわトップス',
            imgUrl      : '/images/items/AM-458.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            id          : 'AM-459',
            rare        : 'R',
            name        : 'スクール☆ガールゆめかわスカート',
            imgUrl      : '/images/items/AM-459.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            id          : 'AM-460',
            rare        : 'R',
            name        : 'スクール☆ガールゆめかわシューズ',
            imgUrl      : '/images/items/AM-460.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            id          : 'AM-461',
            rare        : 'R',
            name        : 'スクール☆ガールゆめかわヘアアクセ',
            imgUrl      : '/images/items/AM-461.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-462',
            rare        : 'R',
            name        : 'セブンスコーデラブリードレスアナザースタイル',
            imgUrl      : '/images/items/AM-462.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'PR_PR',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-463',
            rare        : 'R',
            name        : 'セブンスコーデラブリーシューズアナザースタイル',
            imgUrl      : '/images/items/AM-463.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PR_PR',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-464',
            rare        : 'R',
            name        : 'セブンスコーデラブリーヘアアクセプラチナスタイル',
            imgUrl      : '/images/items/AM-464.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PR_PR',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'R',
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-465',
            rare        : 'R',
            name        : 'セブンスコーデセクシードレスアナザースタイル',
            imgUrl      : '/images/items/AM-465.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PR_PR',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-466',
            rare        : 'R',
            name        : 'セブンスコーデセクシーシューズアナザースタイル',
            imgUrl      : '/images/items/AM-466.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PR_PR',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-467',
            rare        : 'R',
            name        : 'セブンスコーデセクシーヘアアクセプラチナスタイル',
            imgUrl      : '/images/items/AM-467.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'PR_PR',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-468',
            rare        : 'N',
            name        : 'ロッキンパイレーツターコイズトップス',
            imgUrl      : '/images/items/AM-468.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-469',
            rare        : 'N',
            name        : 'ロッキンパイレーツターコイズスカート',
            imgUrl      : '/images/items/AM-469.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-470',
            rare        : 'N',
            name        : 'ロッキンパイレーツターコイズシューズ',
            imgUrl      : '/images/items/AM-470.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-471',
            rare        : 'N',
            name        : 'ロッキンパイレーツターコイズヘアアクセ',
            imgUrl      : '/images/items/AM-471.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-472',
            rare        : 'N',
            name        : 'トゥインクルスターオレンジトップス',
            imgUrl      : '/images/items/AM-472.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-473',
            rare        : 'N',
            name        : 'トゥインクルスターオレンジスカート',
            imgUrl      : '/images/items/AM-473.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-474',
            rare        : 'N',
            name        : 'トゥインクルスターオレンジシューズ',
            imgUrl      : '/images/items/AM-474.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-475',
            rare        : 'N',
            name        : 'トゥインクルスターオレンジヘアアクセ',
            imgUrl      : '/images/items/AM-475.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-476',
            rare        : 'N',
            name        : 'マドモアゼルルージュパープルワンピ',
            imgUrl      : '/images/items/AM-476.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-477',
            rare        : 'N',
            name        : 'マドモアゼルルージュパープルシューズ',
            imgUrl      : '/images/items/AM-477.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            id          : 'AM-478',
            rare        : 'N',
            name        : 'マドモアゼルルージュパープルヘアアクセ',
            imgUrl      : '/images/items/AM-478.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～オールアイドル編～',
            rare        : 'N',
          }),
        ]
      }
    },

    computed: {
      itemsRR () {
        return _.where(this.items, {  rare: 'RR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="RR ◆◆◆◆" color="#ff5d91" :items="itemsRR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
